import React from 'react'
import { ExplanationType } from '../../../../lib/translation-explanations'

type Props = {
   explanation: string | undefined
   explanationType: ExplanationType
}

const ThaiWordListExplanation = (props: Props) => {
   if (props.explanationType === ExplanationType.Untranslatable) {
      return (
         <div className="text-bodyBlack max-w-[700px] leading-[1.5]">
            <i dangerouslySetInnerHTML={{ __html: props.explanation! }} />.
         </div>
      )
   }

   return null
}

export default ThaiWordListExplanation
